import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import logo from 'src/assets/imgs/logo_big.svg';
import i18n from 'src/services/I18NService';
import LanguageSelect from 'src/containers/LanguageSelect';

class HeaderLogin extends React.Component<RouteComponentProps> {
  render() {
    return (
      <div className="login-header">
        <img className="login-header-logo" alt="logo" src={logo} />
        <span>{i18n.get('common_partner_title')}</span>
        <div className="login-language">
          <LanguageSelect />
        </div>
      </div>
    );
  }
}

export default withRouter(HeaderLogin);



// WEBPACK FOOTER //
// ./src/components/layouts/HeaderLogin.tsx